import Familiar from './src/pages/HeroSaga/Familiar';
import FamiliarCreate from './src/pages/HeroSaga/Familiar/FamiliarCreate';
import FamiliarUpdate from './src/pages/HeroSaga/Familiar/FamiliarUpdate';
import Boon from './src/pages/HeroSaga/Boon';
import BoonUpdate from './src/pages/HeroSaga/Boon/BoonUpdate';

const MenuFamiliarSaga = [
    {
        id: 'familiar',
        name: 'Familiar',
        icon: 'icon-puzzle',
        path: 'familiar',
        component: Familiar,
        isShown: 1,
    },
    {
        path: 'familiar/create',
        name: 'Familiar > Create',
        component: FamiliarCreate,
        isShown: 0,
    },
    {
        path: 'familiar/update/:id',
        name: 'Familiar > Update',
        component: FamiliarUpdate,
        isShown: 0,
    },
    {
        id: 'boon',
        name: 'Boon',
        icon: 'icon-fire',
        path: 'boon',
        component: Boon,
        isShown: 1,
    },
    {
        path: 'boon/update/:id',
        name: 'Boon > Update',
        component: BoonUpdate,
        isShown: 0,
    },
];

export default MenuFamiliarSaga;
